import { ProjectStatus } from 'src/utils/types';
export const filterButtons = [{
  label: 'All'
}, {
  label: 'Upcoming',
  projectStatus: ProjectStatus.UPCOMING
}, {
  label: 'Live',
  projectStatus: ProjectStatus.LIVE
}, {
  label: 'Finished',
  projectStatus: ProjectStatus.ENDED
}, {
  label: 'My Launches',
  projectStatus: 'my-list'
}, {
  label: 'Refunded',
  projectStatus: ProjectStatus.REFUNDED
}];